export const CHOIX_POPULATION_IDS = {
  TOUTE: "toute",
  GROUPE: "groupe",
  INSTITUTIONS: "institutions",
};

export const CHOIX_POPULATION = [
  {
    id: CHOIX_POPULATION_IDS.TOUTE,
    libelle: "Toute la population",
  },
  {
    id: CHOIX_POPULATION_IDS.GROUPE,
    libelle: "Un groupe de personnes",
  },
  {
    id: CHOIX_POPULATION_IDS.INSTITUTIONS,
    libelle: "Des institutions",
  },
];
